import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const startMocks = async () => {
  if (process.env.NODE_ENV === 'development') {
    const { worker } = await import('./mocks/browser');
    await worker.start({ onUnhandledRequest: 'bypass' });
  }
};

const colorSchemeMedia = window.matchMedia('(prefers-color-scheme: dark)');
const applyTheme = (event) => {
  const isDark = event.matches ?? colorSchemeMedia.matches;
  document.body.setAttribute('data-theme', isDark ? 'dark' : 'light');
};
applyTheme(colorSchemeMedia);
if (colorSchemeMedia.addEventListener) {
  colorSchemeMedia.addEventListener('change', applyTheme);
} else if (colorSchemeMedia.addListener) {
  colorSchemeMedia.addListener(applyTheme);
}

const startApp = () => {
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

startMocks()
  .catch(() => {})
  .finally(() => {
    startApp();
    serviceWorkerRegistration.register();
  });
